<template>
  <div class="container" id="coach_list_outer" v-if="coachList != null">
    <h3 style="margin-top: 50px;">协会认证教练员列表</h3>

    <div class="btn-toolbar" role="toolbar">
      <button type="button" :class="['btn','btn-default', {'active': (filterIndex == 0) }]" v-on:click="filterAllClicked">全部教练员</button>

      <div class="btn-group">
        <button type="button" :class="['btn', 'btn-default', 'dropdown-toggle', {'active': (nameSelectedItem != null) }]" data-toggle="dropdown" >
          {{ nameSelectedItem != null ? nameSelectedItem : '按名称' }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li v-for="(item, index) in nameList" :key="'name_item_' + index"><a href="javascript:void(0)" v-on:click="filterByName(index)" :class="{'active': (levelSelectedItem == item)}">{{item}}</a> </li>
        </ul>
      </div>

      <div class="btn-group">
        <button type="button" :disabled="currentLevelList.length == 0" :class="['btn', 'btn-default', 'dropdown-toggle', {'active': (levelSelectedItem != null) }]" data-toggle="dropdown" >
          {{ levelSelectedItem != null ? levelSelectedItem : '按等级' }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li v-for="(item, index) in currentLevelList" :key="'level_' + index"><a href="javascript:void(0)" v-on:click="filterByLevel(index)" :class="{'active': (levelSelectedItem == item)}">{{item}}</a> </li>
        </ul>
      </div>

      <div class="btn-group">
        <button type="button" :class="['btn', 'btn-default', 'dropdown-toggle', {'active': (areaSelectedItem != null) }]" data-toggle="dropdown" >
          {{ areaSelectedItem != null ? areaSelectedItem : '按区域' }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li v-for="(item, index) in areaFilters" :key="'level_' + index"><a href="javascript:void(0)" v-on:click="filterByArea(index)" :class="{'active': (areaSelectedItem == item)}">{{item}}</a> </li>
        </ul>
      </div>

      <div class="btn-group top-search">
        <el-input v-model="searchKeyword" placeholder="请输入内容" prefix-icon="el-icon-search" clearable>
          <el-button slot="append" @click="seachButtonClicked" >搜索</el-button>
        </el-input>
      </div>
    </div>
    <div v-if="coachList.length > 0" class="list-view">
      <div class="referee-item" v-for="(item, index) in coachList" :key="'referee-item' + index">
        <el-image fit="contain" v-if="item.photo != null && item.photo.length > 0" class="user-image" :src="item.photo" />
        <el-image v-else class="user-image" fit="contain" :src="defaultHeaderImage()" />
        <div class="user-infors">
          <div class="nickname">{{item.name}}</div>
          <div v-if="isCompleted(item)" :class="['status-label', 'active']">认证有效期内</div>
          <div class="other-subtitle"><strong>性别：</strong> {{item.sex}}</div>
          <div class="other-subtitle"><strong>教练员资质：</strong><br>
            <div class="other-subtitle" style="margin-top: 3px;">{{item.cate}} <span style="margin-left: 5px;">{{item.level}}</span></div>
          </div>
          <div class="other-subtitle"><strong>认证有效期：</strong><br>
            {{coachValidDateString(item)}}
          </div>
        </div>

        <a class="click-event" href="javascript:void(0)" v-on:click="openCoachDetail(index)"></a>
      </div>

      <loading-view v-if="showBottomLoading" :index="loadingIndex" />

    </div>
    <div v-else class="none-data">
      暂无相关信息
    </div>


  </div>
</template>

<script>
  import UserDefaultImage from '../assets/shl_personal_head_portrait_gold_default.png'
  import userDefaultRedIcon from "../assets/shl_personal_head_portrait_red_default.png";
  import BottomLoadingView from "../components/common/BottomLoading.vue";
export default {
  name: "coachListPage",
  components: {
    'loading-view': BottomLoadingView,
  },
  data() {
    return {
      isLoading: false,
      coachList: null,
      pageIndex: 0,
      pageSize: 12,
      filterIndex: 0,
      nameIndex: -1,
      nameSelectedItem: null,
      levelSelectedItem: null,
      areaSelectedItem: null,
      searchKeyword: '',
      islastSearchKey: false,
      showBottomLoading: false,
      loadingIndex: 0,
      isFirstLoading: false,

      nameList: [
        '篮球教练员职称',
        '社会体育指导员职业资格证书',
        '体育类教师资格证',
        '中国篮球协会教练员等级证',
        '境外篮球教练员证书',
        '其他体育职业技能等级证书'
      ],

      levelList: [
        [
          '国家级',
          '高级',
          '中级',
          '初级'
        ],
        [
          '一级/高级技师',
          '二级/技师',
          '三级/高级',
          '四级/中级工',
          '五级/初级工'
        ],
        [
          '体育教师资格证',
        ],
        [
          'A级',
          'B级',
          'C级',
          'D级',
          'E级'
        ],
        [
          'FIBA3级',
          'FIBA2级',
          'FIBA1级',
          'FIBA Mini级',
          '其他境外篮球教练员等级'
        ],
        []
      ],

      areaFilters: [
        '黄浦区',
        '静安区',
        '长宁区',
        '普陀区',
        '虹口区',
        '杨浦区',
        '浦东新区',
        '闵行区',
        '徐汇区',
        '宝山区',
        '嘉定区',
        '金山区',
        '松江区',
        '青浦区',
        '奉贤区',
        '崇明区',
        '学生体协',
        '上海体院',
        '其他行业体协'
      ],
      registerScrollListener: false,
    }
  },

  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    currentLevelList() {
      let nameIndex = this.nameIndex;
      if (nameIndex < 0) {
        return [];
      }
      return this.levelList[nameIndex];
    },
    user() {
      return this.$store.state.user;
    },
    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },
    defaultHeaderImage() {
      return this.isVip ? userDefaultGoldIcon : userDefaultRedIcon;
    },
  },

  mounted() {
    this.isFirstLoading = true;
    this.loadData();
    this.addScrollListener();
  },

  destroyed() {
    this.removeScrollListener();
  },
  methods: {
    seachButtonClicked() {
      let keyword = this.searchKeyword.removeNamesBlank();
      this.pageIndex = 0;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.islastSearchKey = true;
      this.loadData();
    },
    coachBeginDate(item) {
      if (item == null) {
        return null;
      }
      let auditTime = item.auditTime;
      if (auditTime == null || auditTime == '') {
        return null;
      }
      let date = this.$moment(auditTime);
      return date;
    },

    coachValidDate(item) {
      if (item == null) {
        return null;
      }
      let auditTime = item.auditTime;
      if (auditTime == null || auditTime == '') {
        return null;
      }
      let beginDate = this.coachBeginDate(item);
      if (beginDate == null) {
        return null
      }
      return beginDate.add(2, 'years');
    },

    isCompleted(item) {
      if (item == null) {
        return false;
      }
      let validDate = this.coachValidDate(item);
      if (validDate == null) {
        return false;
      }
      let now = this.$moment();
      if (validDate - now > 0) { // 未过期
        return true;
      }
      return false;
    },
    coachValidDateString(item) {
      let beginDate = this.coachBeginDate(item);
      let endDate = this.coachValidDate(item);
      return beginDate.format('yyyy-MM-DD') + ' 至 ' + endDate.format('yyyy-MM-DD');
    },

    addScrollListener() {
      window.onscroll = this.scrollListener;
      this.registerScrollListener = true;
    },

    removeScrollListener() {
      document.removeEventListener('mousewheel', this.scrollListener);
      this.registerScrollListener = false;
    },

    scrollListener: function(event) {
      this.loadMore();
    },

    getScrollTop() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    //获取当前可视范围的高度
    getClientHeight() {
      let clientHeight = 0;
      if(document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      }
      return clientHeight;
    },
    //获取文档完整的高度
    getScrollHeight() {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    },

    loadMore() {
      if ( this.getScrollTop() + this.getClientHeight() + 50 - this.getScrollHeight() > 20 && !this.isLoading) {
        this.loadData();
      }
    },

    loadData() {
      if (this.isLoading || this.loadingIndex == 2) {
        return;
      }

      if (!this.registerScrollListener) {
        this.addScrollListener();
      }

      this.isLoading = true;
      let pageIndex = this.pageIndex;
      if (!this.isFirstLoading) {
        this.showBottomLoading = true;
        this.loadingIndex = 1;
      } else {
        this.showBottomLoading = false;
      }
      pageIndex += 1;
      let keyword = this.searchKeyword.removeNamesBlank();

      let params = {
        pageIndex,
        size: this.pageSize,
        keyword: keyword,
      };

      if (this.areaSelectedItem != null && this.areaSelectedItem.length > 0) {
        params.area = this.areaSelectedItem;
      }

      if (this.levelSelectedItem != null && this.levelSelectedItem.length > 0) {
        params.level = this.levelSelectedItem;
      }

      if (this.nameSelectedItem != null && this.nameSelectedItem.length > 0) {
        params.name = this.nameSelectedItem;
      }
      let _this = this;
      this.httpManager.ajax.getCoachListData(params, function (data) {
        if (!_this.showBottomLoading) {
          _this.showBottomLoading = true;
        }
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          if (_this.isFirstLoading) {
            _this.isFirstLoading = false;
          }
          let itemArray = data.data;
          console.log(itemArray);
          if (pageIndex == 1) {
            _this.coachList = [];
          }

          if (itemArray.length > 0) {
            _this.coachList = _this.coachList.concat(itemArray);
            _this.pageIndex += 1;
            if (itemArray.length == _this.pageSize) {
              _this.loadingIndex = 0;
            } else {
              _this.loadingIndex = 2;
            }
          } else {
            _this.loadingIndex = 2;
            _this.removeScrollListener();
          }
          return;
        }
        _this.loadingIndex = 0;
        _this.$toast("数据加载失败");
      },function (data) {
        _this.loadingIndex = 0;
        _this.isLoading = false;
        _this.$toast("数据加载失败，请刷新！");
      })
    },

    isDateValid(item) {
     if (item != null) {
       return !(item.reviewed == 0);
     }
      return false;
    },

    openCoachDetail: function (index) {
      let item = this.coachList[index];
      // if (item.reviewed == 0) {
      //   this.$toast("正在年检，无法查看！");
      //   return;
      // }
      console.log(item);
      let id = item.id;
      this.$router.push({
        name: 'coachDetailVue',
        params: {
          coachId: id
        }
      });
    },
    filterAllClicked: function () {
      if (!this.islastSearchKey && this.filterIndex == 0) {
        return;
      }
      this.pageIndex = 0;
      this.filterIndex = 0;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.searchKeyword = '';
      this.islastSearchKey = false;
      this.nameIndex = -1;
      this.nameSelectedItem = null;
      this.areaSelectedItem = null;
      this.levelSelectedItem = null;
      this.coachList = null;
      this.loadData();
    },
    filterByArea: function (index) {
      let name = this.areaFilters[index];
      if (!this.islastSearchKey && this.filterIndex == 3 && name == this.areaSelectedItem ) {
        return;
      }

      this.pageIndex = 0;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.searchKeyword = '';
      this.islastSearchKey = false;
      this.filterIndex = 3;
      this.areaSelectedItem = name;
      this.coachList = null;
      this.loadData();
    },

    filterByName(index) {
      let name = this.nameList[index];
      if (!this.islastSearchKey && this.filterIndex == 1 && name == this.nameSelectedItem) {
        return;
      }
      this.pageIndex = 0;
      this.filterIndex = 1;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.searchKeyword = '';
      this.islastSearchKey = false;
      this.nameSelectedItem = name;
      this.levelSelectedItem = null;
      this.nameIndex = index;
      this.coachList = null;
      this.loadData();
    },


    filterByLevel: function (index) {
      let name = this.currentLevelList[index];
      if (!this.islastSearchKey && this.filterIndex == 2 && name == this.levelSelectedItem) {
        return;
      }
      this.pageIndex = 0;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.searchKeyword = '';
      this.islastSearchKey = false;
      this.filterIndex = 2;
      this.levelSelectedItem = name;
      this.coachList = null;
      this.loadData();
    }
  }
}
</script>

<style scoped>

  #coach_list_outer .btn-toolbar {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    border: solid 1px #fc1a34;
    margin-left: 0px;
    border-bottom: 0px;
    padding-top: 5px;
  }

  #coach_list_outer .btn-toolbar .btn-default {
    border: solid 1px #fc1a34;
    margin-bottom: 5px;
    padding: 7px 5px;
  }


  #coach_list_outer .top-search {
    width: 250px;
    height: 45px;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: solid 1px #FC1A34;
    border-radius: 4px;
    margin-bottom: 5px;
  }
  #coach_list_outer .top-search .el-input {
    height: 100%;
  }

  #coach_list_outer .top-search .el-input .el-button {
    background-color: #FC1A34;
    color: white;
    height: 100%;
    font-size: 15px;
  }
  #coach_list_outer .top-search .el-input .el-button:hover, #coach_list_outer .top-search .el-input .el-button:focus {
    color: #eee;
  }

  #coach_list_outer .top-search /deep/ .el-input__inner, #coach_list_outer .top-search .el-textarea__inner {
    height: 100%;
    border: none;
  }


  @media screen and (min-width: 625px){


    #coach_list_outer .top-search {
      width: 250px;
      height: 45px;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: solid 1px #FC1A34;
      border-bottom: none;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: 0px;
    }

    #coach_list_outer .btn-toolbar {
      display: block;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 30px;
      border: none;
      margin-left: 0;
      padding-top: 0;
    }

    #coach_list_outer .btn-toolbar .btn-default {
      border: solid 1px #fc1a34;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
      margin-bottom: 0px;
      padding: 10px 7px;
      margin-left: 0;
    }
    #coach_list_outer .btn-toolbar > *:not(:first-child) {
      margin-left: 2px;
    }
  }

  @media screen and (min-width: 768px){
    #coach_list_outer .btn-toolbar > *:not(:first-child) {
      margin-left: 5px;
    }

    #coach_list_outer .btn-toolbar .btn-default {
      padding: 10px 15px;
    }
  }

  #coach_list_outer .btn-toolbar .btn-default:hover {
    color: #fc1a34;
  }

  #coach_list_outer .btn-toolbar .btn-default.active {
    background-color: white;
    color: #fc1a34;
  }

  #coach_list_outer .btn-toolbar .btn-default {
    font-size: 1.2rem;
  }

  #coach_list_outer .btn-toolbar .dropdown-menu li > a:hover {
    color: #fc1a34;
  }

  #coach_list_outer .btn-toolbar .dropdown-menu li > a.active {
    color: #fc1a34;
  }

  #coach_list_outer .list-view {
    border: solid 1px #fc1a34;
    padding-bottom: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
  }

  #coach_list_outer .none-data {
    height: 150px;
    font-size: 1.5rem;
    color: #666;
    line-height: 150px;
    border: solid 1px #fc1a34;

  }

  #coach_list_outer .referee-item {
    position: relative;
    border: solid 1px #fc1a34;
    height: 200px;
    min-width: 220px;
    width: 90%;
    margin-top: 15px;
    text-align: left;
    padding: 5px 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  .referee-item .user-image {
    width: 80px;
    height: 100px;
    background-color: white;
  }

  .referee-item .click-event {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    text-decoration: none;
    /*background-color: rgba(0, 255, 0, 0.3);*/
  }

  .referee-item .user-infors {
    margin-left: 15px;
    /*background-color: yellow;*/
  }

  .referee-item .user-infors > div:not(:first-child) {
    margin-top: 4px;
  }

  .user-infors .nickname {
    font-size: 1.4rem;
    color: #333;
  }

  .user-infors .status-label {
    font-size: smaller;
    color: gray;
    border: solid 1px gray;
    text-align: center;
    margin-top: 3px;
    vertical-align: middle;
    width: 100px;
  }

  .user-infors .status-label.active {
    color: green;
    border: solid 1px green;
  }

  .user-infors .other-subtitle {
    font-size: smaller;
    color: #333;
  }

  @media screen and (min-width: 320px) {
    #coach_list_outer .referee-item {
      padding: 5px 10px;
      min-width: 280px;
      width: 90%;
    }

    .referee-item .user-infors {
      margin-left: 15px;
    }
    .referee-item .user-image {
      width: 120px;
      height: 150px;
      /* border-radius: 60px; */
    }
  }

  #coach_list_outer .btn-default:focus {
    color: white;
  }

  @media screen and (min-width: 768px) {
    #coach_list_outer .referee-item {
      width: 45%;
      margin-left: 3.33%;
      justify-content: flex-start;
    }

    #coach_list_outer .list-view {
      justify-content: flex-start;
    }
  }

  @media screen and (min-width: 1000px) {
    #coach_list_outer .referee-item {
      width: 30%;
      margin-left: 2.5%;
    }
    #coach_list_outer .list-view {
      justify-content: flex-start;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/CoachListPage.vue